var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { getCommunicationBannerData } from '@homeexchange/navigation-bar';
import { Icon } from '@homeexchange/design';
import Analytics from '../../utils/analytics';
import _ from 'underscore';
import { useDevice } from '@homeexchange/shared';
import Storage from '../../utils/Storage';
export function CommunicationBanner(_a) {
    var _this = this;
    var _b, _c;
    var locale = _a.locale, area = _a.area;
    var _d = useState(false), isDismissed = _d[0], setIsDismissed = _d[1];
    var _e = useState(undefined), data = _e[0], setData = _e[1];
    var isMobile = useDevice().isMobile;
    var headNavBandElement = document.getElementById('head-nav-band');
    var getStorageKey = function (campaign) { return "banner_".concat(campaign, "_dismissed"); };
    var getData = function () { return __awaiter(_this, void 0, void 0, function () {
        var data_1, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getCommunicationBannerData(locale)];
                case 1:
                    data_1 = _c.sent();
                    setData(data_1);
                    if ((_b = (_a = data_1 === null || data_1 === void 0 ? void 0 : data_1.communicationBanner) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.campaignName) {
                        setIsDismissed(Storage.get(getStorageKey(data_1.communicationBanner.data.campaignName)) || false);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getData();
    }, []);
    useEffect(function () {
        if (!data || isDismissed) {
            return;
        }
        trackBanner('view');
        updateNavBandHeight();
        // fix profile menu height when banner is displayed
        window.dispatchEvent(new Event('resize'));
    }, [data]);
    useEffect(function () {
        if (!data) {
            return;
        }
        updateNavBandHeight();
    }, [data, isDismissed]);
    var updateNavBandHeight = function () {
        document.body.style.setProperty('--nav-band-dynamic-height', "".concat(headNavBandElement.offsetHeight, "px"));
    };
    useEffect(function () {
        window.addEventListener('resize', updateNavBandHeight);
        return function () { return window.removeEventListener('resize', updateNavBandHeight); };
    }, []);
    var dismissBanner = function () {
        if (!isMobile) {
            return;
        }
        Storage.set(getStorageKey(data.communicationBanner.data.campaignName), "".concat(true));
        setIsDismissed(true);
    };
    var trackBanner = function (action, callback) {
        var _a = data.communicationBanner, cluster = _a.cluster, bannerData = _a.data;
        var campaignName = bannerData.campaignName;
        var text = "communication_banner_".concat(campaignName, "_user_").concat(cluster);
        Analytics.trackGTM('banner', { event_data: { action: action, area: area, text: text } }, callback);
    };
    var handleOnClick = function () {
        trackBanner('click', _.debounce(function () {
            dismissBanner();
            if (data.communicationBanner.data.newTab) {
                window.open(data.communicationBanner.data.link, '_blank', 'noopener noreferrer');
            }
            else {
                document.location.assign(data.communicationBanner.data.link);
            }
        }, 500, true));
    };
    return (data &&
        !isDismissed && (React.createElement("a", { className: "communication-banner-link", onClick: handleOnClick },
        React.createElement("div", { className: "communication-banner" },
            React.createElement("div", { style: {
                    marginBottom: 0
                }, dangerouslySetInnerHTML: {
                    __html: (_c = (_b = data.communicationBanner) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.text
                } }),
            React.createElement(Icon, { name: "angle-right-rounded", size: "2xl", className: "icon" })))));
}
